import { Injectable } from '@angular/core';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Stripe, StripeCardElement } from '@stripe/stripe-js';
import { StripePaymentIntent } from '../models/order.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class StripeService {
  private wineristStripeAccount: Stripe;

  public async elements() {
    const stripe = await this.getStripeSdk();

    return stripe.elements();
  }

  public async createPaymentMethod(card: StripeCardElement) {
    const stripe = await this.getStripeSdk();

    return stripe.createPaymentMethod({ type: 'card', card });
  }

  public async confirmCardPayment(data: StripePaymentIntent) {
    const { clientSecret, stripePaymentMethodId, stripeConnectedAccountId } = data;
    const stripe = await this.getStripeSdk(stripeConnectedAccountId);

    return stripe.confirmCardPayment(clientSecret, { payment_method: stripePaymentMethodId });
  }

  private async getStripeSdk(connectedAccountId: string = undefined): Promise<Stripe> {
    if (connectedAccountId) {
      return loadStripe(environment.stripeKey, { stripeAccount: connectedAccountId });
    }

    if (this.wineristStripeAccount) {
      return this.wineristStripeAccount;
    }

    this.wineristStripeAccount = await loadStripe(environment.stripeKey);

    return this.wineristStripeAccount;
  }
}
